export enum BedarfVerbrauchType {
  BEDARF = 'BEDARF',
  VERBRAUCH = 'VERBRAUCH',
}

export interface BedarfVerbrauchLabelProps {
  type: BedarfVerbrauchType
}
